import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import 'locomotive-scroll/dist/locomotive-scroll.css'

const app = createApp(App)

// 添加路由守卫，动态更新页面标题和meta描述
router.beforeEach((to, from, next) => {
  // 更新页面标题
  if (to.meta.title) {
    document.title = to.meta.title
  }
  
  // 更新meta描述
  if (to.meta.description) {
    const descriptionMeta = document.querySelector('meta[name="description"]')
    if (descriptionMeta) {
      descriptionMeta.setAttribute('content', to.meta.description)
    }
  }
  
  next()
})

app.use(router)
app.mount('#app')
